<template>
    <div>
        <PageSpinner :onloader="onloader" />
        <base-header type="gradient-success" class="pb-6 pb-8 pt-5 pt-md-8">
            <router-link to="/dashboard" class="text-white pl-3">
                Dashboard </router-link>
            <span class="text-white"><i class="fa fa-ellipsis-v"></i> School Subjects</span>
        </base-header>

        <!--Charts-->
        <div class="container-fluid mt--7">
            <modal :show.sync="modals.schoolSubjectModal" modal-classes="modal-dialog-centered modal-lg">
                <div class="card bg-secondary border-0 mb-0">
                    <div class="card-body">
                        <PageSpinner :onloader="onloader" />
                        <form role="form">
                            <div class="form-group">
                                <label>Subject Name</label>
                                <input v-model="SchoolSubjectNameVal" class="form-control" />
                            </div>
                            <div class="form-group">
                                <label>Subject Code</label>
                                <input v-model="SchoolSubjectCodeVal" class="form-control" />
                            </div>
                        </form>
                    </div>
                </div>
                <template slot="footer">
                    <base-button type="default" @click="modals.schoolSubjectModal = false">Cancel
                    </base-button>
                    <base-button type="success" @click.prevent="SubmitSchoolSubject()">Submit
                    </base-button>
                </template>
            </modal>
            <card header-classes="bg-transparent">
                <div>
                    <div class="form-inline">
                        <select v-model="SchoolTypeIdval" class="form-control" @change="GetSchoolsForPortal()"
                            :disabled="SchoolTypeItems === null">
                            <option value="0">{{ SchoolTypeItems === null ? '⏳ Loading...' : '- Select School Type-'
                            }}</option>
                            <option v-for="item in SchoolTypeItems" :key="item.schoolTypeId"
                                v-bind:value="item.schoolTypeId">
                                {{ item.schoolTypeName }}
                            </option>
                        </select>
                        <select v-model="SchoolIdval" class="form-control ml-2" @change="GetSchoolLevels()"
                            :disabled="SchoolItems === null">
                            <option value="0">{{ SchoolItems === null ? '⏳ Loading...' : '- Select School -'
                            }}</option>
                            <option v-for="item in SchoolItems" :key="item.schoolId" v-bind:value="item.schoolId">
                                {{ item.schoolName }}
                            </option>
                        </select>
                        <select v-model="SchoolLevelIdval" class="form-control ml-2" @change="GetSchoolSubjects()"
                            :disabled="SchoolLevelItems === null">
                            <option value="0">{{ SchoolLevelItems === null ? '⏳ Loading...' : '- Select Level -'
                            }}</option>
                            <option v-for="item in SchoolLevelItems" :key="item.schoolLevelId"
                                v-bind:value="item.schoolLevelId">
                                {{ item.schoolLevelName }}
                            </option>
                        </select>
                        <button class="btn btn-success mr-3" v-on:click="OpenSchoolSubjectModal()"
                            v-if="SchoolLevelIdval">
                            <i class="fa fa-edit"></i> New
                        </button>
                        <div class="input-group" v-if="SchoolTypeIdval">
                            <base-input class="input-group-alternative" placeholder="Search here..."
                                addon-left-icon="fa fa-search" v-model="searchval">
                            </base-input>
                        </div>
                    </div>
                    <div class="mt-2">
                        <list-skeleton v-if="!SchoolSubjectItems" :rows="3" />
                        <div v-else class="table-responsive mt-2">
                            <table class="table table-borderless table-striped table-hover table-sm">
                                <thead>
                                    <tr>
                                        <th>Subject Name</th>
                                        <th>Subject Code</th>
                                        <th></th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="item in searchedResultQuery" :key="item.schoolSubjectId">
                                        <td class="align-middle" data-label="Subject Name">{{
                                            item.schoolSubjectName }}
                                        </td>
                                        <td class="align-middle" data-label="Subject Code">{{
                                            item.schoolSubjectCode
                                            }}</td>
                                        <td class="align-middle actions-cell" data-label="Actions">
                                            <div
                                                class="d-flex flex-column flex-sm-row justify-content-center align-items-center">
                                                <button class="btn btn-outline-primary btn-sm rounded-pill m-1"
                                                    title="Edit" @click.prevent="EditSchoolSubject(item)">
                                                    <i class="fa fa-edit"></i>
                                                </button>
                                            </div>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </card>
        </div>
    </div>
</template>

<script>
import Alert from "@/mixins/Alert.mixins"
import PageSpinner from "@/components/PageSpinner";
// import ValidateAccessToken from "@/mixins/ValidateAccessToken.mixin"

export default {
    name: "cbt-exam",
    mixins: [Alert],
    components: {
        PageSpinner
    },
    data() {
        return {
            accessDetails: null,
            SchoolSubjectIdVal: 0,
            SchoolTypeIdval: 0,
            SchoolLevelIdval: 0,
            SchoolIdval: 0,
            SchoolSubjectNameVal: "",
            SchoolSubjectCodeVal: "",
            SchoolSubjectItems: null,
            SchoolLevelItems: null,
            SchoolTypeItems: null,
            SchoolItems: null,
            searchval: "",
            isModified: false,
            onloader: "none",
            modals: {
                schoolSubjectModal: false
            }
        };
    },
    computed: {
        searchedResultQuery() {
            if (this.searchval) {
                return this.SchoolSubjectItems.filter((item) => {
                    return this.searchval
                        .toLowerCase()
                        .split(" ")
                        .every(
                            (v) =>
                                item.schoolSubjectName.includes(v) ||
                                item.schoolSubjectCode.toLowerCase().includes(v)
                        );
                });
            } else {
                return this.SchoolSubjectItems;
            }
        },
    },
    methods: {
        OpenSchoolSubjectModal() {
            this.resetInput();
            this.modals.schoolSubjectModal = true
        },
        resetInput() {
            this.SchoolSubjectNameVal = "";
            this.SchoolSubjectCodeVal = "";
            this.isModified = false;
        },
        EditSchoolSubject(item) {            
            this.SchoolSubjectIdVal = item.schoolSubjectId;
            this.SchoolSubjectNameVal = item.schoolSubjectName;
            this.SchoolSubjectCodeVal = item.schoolSubjectCode;
            this.isModified = true;
            this.modals.schoolSubjectModal = true
        },
        SubmitSchoolSubject() {
            let schoolSubjectId = this.SchoolSubjectIdVal;
            let schoolSubjectName = this.SchoolSubjectNameVal;
            let schoolSubjectCode = this.SchoolSubjectCodeVal;
            let schoolId = this.SchoolIdval;
            let schoolLevelId = this.SchoolLevelIdval;
            let userdata = {};
            this.onloader = "flex";
            let operationVal = "";
            if (this.isModified == false) {
                operationVal = "SchoolSubject/CreateSchoolSubject";
                userdata = {
                    schoolSubjectName,
                    schoolSubjectCode,
                    schoolId,
                    schoolLevelId
                }
            } else {
                operationVal = "SchoolSubject/UpdateSchoolSubject";
                userdata = {
                    schoolSubjectId,
                    schoolSubjectName,
                    schoolSubjectCode,
                    schoolId,
                    schoolLevelId
                }
            }
            this.$store
                .dispatch(operationVal, userdata)
                .then((resp) => {
                    this.onloader = "none";
                    if (resp.responseCode == '00') {
                        this.GetSchoolSubjects();
                        this.resetInput();
                        this.modals.schoolSubjectModal = false;
                        this.ShowAlertSuccess('Submitted successfully', '');
                    } else {
                        this.ShowAlertError(resp.responseMessage, '');
                    }

                })
                .catch((err) => {
                    this.onloader = "none";
                    this.ShowAlertError(err.response.data, '');
                });
        },
        GetSchoolTypeForPortal() {
            this.onloader = "flex";
            this.$store
                .dispatch("SchoolType/GetSchoolTypeForPortal")
                .then((resp) => {
                    this.SchoolTypeItems = resp.data;
                    this.onloader = "none";
                })
                .catch((err) => {
                    console.log(err);
                    this.onloader = "none";
                });
        },
        GetSchoolsForPortal() {
            let SchoolTypeId = this.SchoolTypeIdval;
            if (SchoolTypeId > 0) {
                this.onloader = "flex";
                this.$store
                    .dispatch("School/GetSchoolsForPortal", SchoolTypeId)
                    .then((resp) => {
                        this.SchoolItems = resp.data;
                        this.onloader = "none";
                    })
                    .catch((err) => {
                        this.onloader = "none";
                        this.ShowAlertError(err.response.data, '');
                    });
            }
        },
        GetSchoolLevels() {
            let SchoolTypeId = this.SchoolTypeIdval;
            if (SchoolTypeId > 0) {
                this.onloader = "flex";
                const userData = {
                    SchoolTypeId
                }
                this.$store
                    .dispatch("SchoolLevel/GetSchoolLevels", userData)
                    .then((resp) => {
                        this.SchoolLevelItems = resp.data;
                        this.onloader = "none";
                    })
                    .catch((err) => {
                        this.onloader = "none";
                        this.ShowAlertError(err.response.data, '');
                    });
            }
        },
        GetSchoolSubjects() {
            let SchoolId = this.SchoolIdval;
            let SchoolLevelId = this.SchoolLevelIdval;
            if (SchoolLevelId > 0) {
                this.onloader = "flex";
                const userData = {
                    SchoolId,
                    SchoolLevelId
                }
                this.$store
                    .dispatch("SchoolSubject/GetSchoolSubjects", userData)
                    .then((resp) => {
                        this.SchoolSubjectItems = resp.data;
                        this.onloader = "none";
                    })
                    .catch((err) => {
                        this.onloader = "none";
                        this.ShowAlertError(err.response.data, '');
                    });
            }
        },
    },
    mounted() {
        const userDetails = this.accessDetails = this.$store.getters['auth/_user'];
        if (
            userDetails.isSuperAdmin == true ||
            userDetails.isAdmin == true ||
            userDetails.isSupportAdmin == true
        ) {
            this.GetSchoolTypeForPortal();
        } else {
            this.$store.dispatch("logout");
            this.$router.push("/login");
        }
    },
};
</script>

<style scoped>
/* Mobile-friendly table: stack rows as cards below 576px */
@media (max-width: 576px) {
    .table-responsive table thead {
        display: none;
    }

    .table-responsive table,
    .table-responsive table tbody,
    .table-responsive table tr,
    .table-responsive table td {
        display: block;
        width: 100%;
    }

    .table-responsive table tr {
        margin-bottom: 0.75rem;
        border: 1px solid rgba(0, 0, 0, 0.05);
        padding: 0.5rem;
        border-radius: 6px;
        background: #fff;
    }

    .table-responsive table td {
        padding: 0.25rem 0.5rem;
        text-align: right;
        position: relative;
    }

    .table-responsive table td::before {
        content: attr(data-label) ": ";
        float: left;
        font-weight: 600;
        text-transform: none;
        color: #495057;
    }

    .form-control,
    .form-control-sm {
        width: 100%;
    }
}

/* Custom dropdown for actions to avoid Bootstrap JS and clipping inside table-responsive */
.action-dropdown {
    position: absolute;
    right: 0;
    top: 36px;
    min-width: 180px;
    z-index: 1100;
    background: #fff;
    border: 1px solid rgba(0, 0, 0, 0.08);
    box-shadow: 0 6px 12px rgba(0, 0, 0, 0.175);
    border-radius: 4px;
    padding: 0.25rem 0;
}

.action-dropdown a {
    display: flex;
    align-items: center;
    padding: 0.5rem 0.75rem;
    color: #333;
}

.action-dropdown a:hover {
    background: #f7f7f7;
    text-decoration: none;
}

.action-toggle-wrap {
    position: relative;
}

/* Allow dropdown to overflow the table container without showing scrollbars */
.table-responsive {
    overflow: visible !important;
}

/* Mobile: make action buttons stack nicely and use ellipsis as primary control */
@media (max-width: 576px) {
    .actions-cell .d-flex {
        flex-direction: column;
        align-items: stretch;
    }

    .actions-cell .d-flex>button {
        width: 100%;
        margin: 0.25rem 0 !important;
        padding: 0.45rem 0.75rem;
        text-align: left;
    }

    .actions-cell .action-toggle-wrap {
        align-self: flex-end;
    }

    .action-dropdown {
        right: 0;
        left: auto;
        top: 44px;
        min-width: 180px;
    }
}
</style>
